import { useMemo } from "react";
import { Typography } from "antd";
import { TEXT } from "./GroupSkillsProficiencyV2.constants";
import ProficiencyColumnTitle from "./components/ProficiencyColumnTitle";
import ProficiencyBar from "./components/ProficiencyBar";
import SkillNameCell from "./components/SkillNameCell";
import PrioritySkillCell from "./components/PrioritySkillCell";

const useSkillsTableColumns = ({ onProficiencyChange, onTogglePriority, viewType = "group" }) =>
  useMemo(
    () => [
      {
        title: <Typography.Text style={{ textTransform: "uppercase" }}>{TEXT.COL_SKILL_NAME}</Typography.Text>,
        dataIndex: "skill_title",
        key: "skill_title",
        width: "25%",
        render: (title, record) => (
          <SkillNameCell title={title} description={record.skill_description} />
        ),
      },
      {
        title: <ProficiencyColumnTitle viewType={viewType} />,
        key: "proficiency",
        width: "55%",
        render: (_, record, index) => (
          <ProficiencyBar
            skill={record}
            index={index}
            onProficiencyChange={onProficiencyChange}
          />
        ),
      },
      {
        title: (
          <Typography.Text style={{ textTransform: "uppercase" }}>
            {viewType === "employee" ? TEXT.COL_PRIORITY_SKILL_FOR_ROLE : TEXT.COL_PRIORITY_SKILLS}
          </Typography.Text>
        ),
        key: "priority_skill",
        width: "20%",
        align: "center",
        render: (_, record, index) => (
          <PrioritySkillCell
            checked={record.priority_skill}
            onChange={() => onTogglePriority(index)}
          />
        ),
      },
    ],
    [onProficiencyChange, onTogglePriority, viewType]
  );

export default useSkillsTableColumns;
